import React, {useEffect, useState} from 'react';
import {Autocomplete, TextField} from "@mui/material";
import moment from "moment";
import {withStyles} from '@mui/styles';
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import {useSelector} from "react-redux";
import Loader from "../BlueButton/Loader.js";
import BlueButton from "../BlueButton/BlueButton.js";
import Api from "../../Api.js";
import {REACT_APP_API_URL} from "../../config.js";
import CustomDropdown from "./CustomDropdown.js";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import ErrorToast from "../BlueButton/ErrorToast.js";
import SuccessToast from "../BlueButton/SuccessToast.js";


const ValidationTextField = withStyles({
    root: {
        '& input:valid + fieldset': {
            borderColor: '#63c0ba',
            borderWidth: 2,
        },
        '& input:invalid + fieldset': {
            borderColor: 'red',
            borderWidth: 2,
        },
        '& input:valid:focus + fieldset': {
            borderColor: '#63c0ba',
            borderLeftWidth: 6,
            padding: '4px !important', // override inline-style
        },
    },
})(TextField);

function AddRepeatedTaskMany({onHide, show}) {
    const [selectAll, setSelectAll] = useState(false);
    const [endDate, setEndDate] = useState(new Date());
    const [form, setForm] = useState([
        { key: 'name', value: '', errorMessage: 'empty_error', type: 'text', label: '' },
        { key: 'text', value: '', errorMessage: 'empty_error', type: 'text', label: '' },
        {
            key: 'repeated_type',
            value: '',
            errorMessage: 'empty_error',
            type: 'dropDown',
            option: [
                { name: 'daily', value: 1 },
                { name: 'weekly', value: 2 },
                { name: 'monthly', value: 3 },
                { name: 'annual', value: 4 },
            ],
            label: '',
        },
        {
            key: 'repeated_value',
            value: '',
            errorMessage: 'respective_error',
            type: 'number',
            label: '',
        },
        {
            key: 'company',
            value: '',
            option: 'orgs',
            errorMessage: 'select_error',
            type: 'dropDown',
            label: '',
        },
    ]);
    const login = useSelector((state) => state.manager.employee);
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);
    const [limitData, setLimitData] = useState({
        orgs: [],
        taskTemplate: [],
        manager: [],
        stuff: [],
    });
    const [template,setTemplate] = useState(true);

    useEffect(() => {
        (async () => {
            setLimitData({
                orgs: companies.map(s => ({...s,value: s.id,label: s.name,url:REACT_APP_API_URL+'manager-company/'+s.id+'/'})),
                taskTemplate: template.results,
                manager: managers,
                stuff: account.map(s => ({value: s.id,url:REACT_APP_API_URL+'accountant/'+s.id+'/' ,...s,label: s.user.first_name + ' ' + s.user.last_name}))
            })
        })()
    }, [companies,managers,account,template])
    useEffect(() => {
        (async () => {
            const {data} = await Api.taskTemplate()
            setTemplate(data)

        })();
    }, []);


    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const submit = async () => {
        try {
            const url = login.url;
            const profession = localStorage.getItem("profession");
            const company = form[form.length - 1].value;
            const postCompany = [];
            const end_date = moment(endDate).format("YYYY-MM-DD HH:mm:ss");
            const creator = login.user.url;
            const formData = new FormData();

            setSubmitted(true);
            setDisabled(true);

            for (let index = 0; index < company.length; index++) {
                postCompany.push(company[index].value);
            }

            for (let index = 0; index < (parseInt(form[3].value, 10) === 1 ? form.length - 1 : form.length); index++) {
                const element = form[index];
                if (!element.valid && !selectAll && element.key !== "company") {
                    setDisabled(false);
                    return;
                } else if (index !== form.length - 1) {
                    formData.append(element.key, element.value);
                }
            }

            formData.append("creator", creator);
            formData.append(profession, url);
            formData.append("is_active", true);
            formData.append("company", postCompany);
            formData.append("selectAll", selectAll);
            if (end_date) {
                formData.append("end_date", end_date);
            }

            await Api.createRepeatedTaskMany(formData)
            await onHide()

            SuccessToast()
        }catch (e) {
            setDisabled(false);
            ErrorToast()
        }
    };
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submit();
        }
    };

    const getRepeatedType = () => {
        const item = form.find((el) => el.key === "repeated_type");
        return parseInt(item?.value || 0, 10);
    };

    const setIntervalValidation = (min, max, item) => {
        const val = parseInt(item.value, 10);
        return val >= min && val <= max;
    };
    const onChange = (e, item, index) => {
        e.preventDefault();
        const updatedForm = [...form];
        const currentItem = updatedForm[index];
        currentItem.value = e.target.value;
        if (item.key === "repeated_value" && getRepeatedType() === 4) {
            currentItem.value = moment(e.target.value).dayOfYear()
        }
        let valid = false;
        const repeatedType = getRepeatedType();

        switch (item.type) {
            case "number":
                if (item.key === "duration") {
                    valid = currentItem.value > 0 && currentItem.value.length < 4;
                } else if (repeatedType === 2) {
                    valid = setIntervalValidation(1, 7, currentItem);
                } else if (repeatedType === 3) {
                    valid = setIntervalValidation(1, 31, currentItem);
                } else if (repeatedType === 4) {
                    valid = setIntervalValidation(1, 366, currentItem);
                }
                break;
            case "text":
                valid = currentItem.value.length > 0;
                break;
            default:
                break;
        }
        setSubmitted(false);

        currentItem.valid = valid;
        setForm(updatedForm);
    };
    const handleTemplateChange = (e, value) => {
        const updatedForm = form.map(item => {
            if (item.key === "name") {
                return {
                    ...item,
                    value: value ? value.name : "",
                    valid: true
                };
            }
            return item;
        });
        setForm(updatedForm);
    };
    const _renderInput = (item, index) => {
        // Skip rendering if repeated_type is 1 and item is "repeated_value"
        if (getRepeatedType() === 1 && item.key === "repeated_value") return null;
        if (index === 3 && getRepeatedType() === 4) {
            return (
                <div className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                    <TextField
                        id="date"
                        label="Օր"
                        type="date"
                        onChange={(e) => onChange(e, item, index)}
                        variant="outlined"
                        InputProps={{
                            inputProps: {
                                min: moment(new Date()).format("YYYY-MM-DD"), // Set minimum date if needed
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {!item.valid && submitted && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )}
                </div>
            )
        }


        return (
            <div
                key={index}
                className={
                    !item.valid && submitted
                        ? "input-validation input-validation-valid"
                        : "input-validation"
                }
            >
                <ValidationTextField
                    type={item.type}
                    name={item.key}
                    value={item.value}
                    onChange={(e) => onChange(e, item, index)}
                    onBlur={() => {
                        item.active = false;
                        setForm([...form]);
                    }}
                    onFocus={() => {
                        item.active = true;
                        setForm([...form]);
                    }}
                    onKeyDown={keyPress}
                    label={word[item.key]}
                    multiline={true}
                    maxLength={20}
                    variant="outlined"
                    error={!item.valid && submitted}
                    id={
                        !item.valid && submitted
                            ? "validation-outlined-input"
                            : "outlined-helperText"
                    }
                />
                {!item.valid && submitted && (
                    <div className="validation valid-center">
                        {word[item.errorMessage]}
                    </div>
                )}
            </div>
        );
    };
    const _renderDropDown = (item, index) => {
        const animatedComponents = makeAnimated();

        if (item.key === "repeated_type") {
            return (
                <div
                    key={index}
                    className={
                        !item.valid && submitted
                            ? "input-validation input-validation-valid"
                            : "input-validation"
                    }
                >
                    <Autocomplete
                        id="combo-box-demo"
                        options={item.option}
                        getOptionLabel={(option) => word[option.name]}
                        onChange={(e, value) => {
                            item.active = false;
                            item.value = value ? value.value : "";
                            item.valid =
                                item.value === 1 ||
                                item.value === 2 ||
                                item.value === 3 ||
                                item.value === 4;

                            if (item.value === 1 && form[index + 1]) {
                                form[index + 1].valid = true;
                            }

                            setForm([...form]);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={word[item.key]}
                                onKeyDown={keyPress}
                                error={!item.valid && submitted}
                                id={
                                    !item.valid && submitted
                                        ? "validation-outlined-input"
                                        : "outlined-helperText"
                                }
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                    {!item.valid && submitted && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )}
                </div>
            );
        } else if (item.key === "manager" || item.key === "accountant") {
            const options = limitData[item.option];
            return (
                <div
                    key={index}
                    className={
                        !item.valid && submitted
                            ? "input-validation input-validation-valid"
                            : "input-validation"
                    }
                >
                    {options && (
                        <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            options={options}
                            placeholder={word[item.key]}
                            isMulti
                        />
                    )}
                    {!item.valid && submitted && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )}
                </div>
            );
        } else {
            const options = limitData[item.option];
            return (
                <div
                    key={index}
                    className={
                        !item.valid && submitted
                            ? "input-validation input-validation-valid"
                            : "input-validation"
                    }
                >
                    {options && !selectAll && (
                        <Select
                            isLoading={limitData.loader_orgs}
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            options={options}
                            onChange={(list) => {
                                item.active = false;
                                item.value = list;
                                item.valid = list && list.length > 0;
                                setForm([...form]);
                            }}
                            placeholder={word[item.key]}
                            isMulti
                        />
                    )}
                    {!item.valid && submitted && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )}
                </div>
            );
        }
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.new_recommendations}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div className="input-validation">
                                <Autocomplete
                                    loading={!(limitData.taskTemplate && limitData.taskTemplate.length > 0)}
                                    loadingText={
                                        <div className="auto-complete-loader">
                                            <Loader type="Oval" color="#101C2A" height={15} width={15} />
                                        </div>
                                    }
                                    id="combo-box-demo"
                                    options={limitData.taskTemplate}
                                    onChange={handleTemplateChange}
                                    getOptionLabel={option => option.name}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Ընտրել առաջադրանքի վերնագիր"
                                            variant="outlined"
                                            fullWidth
                                            onKeyDown={keyPress}
                                        />
                                    )}
                                />
                            </div>

                            {form.map((item, index) => {
                                if (item.type === "dropDown") {
                                    return _renderDropDown(item, index)
                                }

                                return  _renderInput(item, index)
                            })}

                            <label className="cont">
                                Ընտրել բոլոր կազմակերպությունները
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={() => setSelectAll(!selectAll)}
                                />
                                <span className="checkmark"/>
                            </label>

                            <div className="line-blue"/>

                            {disabled && (
                                <div className="disable-loader">
                                    <Loader type="Oval" color="#101C2A" height={30} width={30} />
                                </div>
                            )}

                            <div className="button-line">
                                <BlueButton
                                    disabled={disabled}
                                    buttonStyle={
                                        !disabled ? "blue-button" : "blue-button blue-button-disabled"
                                    }
                                    title={word.create}
                                    onChangeValue={submit}
                                />
                            </div>
                        </Col>
                    </Row>

                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddRepeatedTaskMany;